import { Stack } from '@mui/material';

import { JumpLoader } from '@/shared/components/loaders';

export const GeneralLoadingFallback = () => {
  return (
    <Stack justifyContent="center" alignItems="center" width="100%">
      <JumpLoader />
    </Stack>
  );
};
